import { Component, Input } from '@angular/core';
import { IFinancialTableData, RowTypes } from '@modeso/aumico-lib-annualreport-fe';
import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';

@Component({
    selector: 'aumico-notes-input-display',
    templateUrl: './notes-input-display.component.html',
    styleUrls: ['./notes-input-display.component.scss'],
})
export class NotesInputDisplayComponent {
    @Input() set sectionNotes(value: IFinancialTableData[]) {
        let data: IFinancialTableData[][] = [[]];
        let currentIndex = 0;

        for (const item of value) {
            if (item.rowType === RowTypes.TABLE_HEAD) {
                currentIndex++;
                data[currentIndex] = [item];
            } else if (currentIndex >= 0) {
                data[currentIndex].push(item);
            }
        }
        data = data.filter((subArray) => subArray.length > 0);
        this.sectionData = data;
    }
    @Input() set printOptionStyles(value: IPrintOptions | undefined) {
        if (value != null) {
            this.textColor = value.styleOptions.textColor;
            this.backgroundColor = value.styleOptions.backgroundColor;
            this.backgroundColorPY = value.styleOptions.backgroundColorPY;
        }
    }

    textColor: string;
    backgroundColor: string;
    backgroundColorPY: string;
    public sectionData: IFinancialTableData[][];
    constructor() {}
}
